import styled from 'styled-components';
import { RedButton, GreenButton } from '../../shared/utils/styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: white;
  border-radius: 3px;
  border: 1px solid red;
  margin: 10px 0px 5px 0px;
  padding: 5px;
  box-sizing: border-box;
`;

export const Message = styled.div`
  font-size: 0.8em;
  font-weight: bold;
  color: red;
  text-transform: none;
  width: 100%;
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  & button {
    color: white;
    height: 30px;
    margin: 5px;
    font-weight: normal;
    font-size: 0.8em;
    text-transform: none;
  }
`;

export const AcceptButton = GreenButton;
export const RejectButton = RedButton;
